import { useI18N } from "@sundae/react-hooks";
import { Dialog } from "@sundae/ui-toolkit";
import { FC } from "react";

import { testIds } from "../../../constants/testIds.constants";
import { useAppContext } from "../../../stores";
import LiquidityContextProvider from "../../../stores/LiquidityContext";
import ZapContextProvider from "../../../stores/LiquidityContext/ZapContext";
import { useZapContext } from "../../../stores/LiquidityContext/ZapContext/context";
import { ELiquidityFlowState, useLiquidityContext } from "../../../stores/LiquidityContext/context";
import ZapFlow from "../../LiquidityComponents/Zap/ZapFlow";
import PoolSelectDialog from "../PoolSelectDialog";

const ZapDialogUI: FC = () => {
  const { t } = useI18N("liquidity");
  const {
    state: {
      activeZapPool,
      dialogs: { liquidity: liquidityDialogs },
    },
  } = useAppContext();
  const {
    state: { liquidityFlowState },
  } = useLiquidityContext();
  const {
    handlers: { handleCloseDialog },
  } = useZapContext();

  return (
    <Dialog
      open={!!activeZapPool && liquidityDialogs.zap.isOpen}
      closeDialog={handleCloseDialog}
      title={t("zap.banner.title")}
      description={
        [
          ELiquidityFlowState.initial,
          ELiquidityFlowState.previewCancelled,
          ELiquidityFlowState.reset,
        ].includes(liquidityFlowState)
          ? t("zap.banner.copy")
          : undefined
      }
    >
      <div className="z-10 grid min-h-[16rem] gap-4" data-testid={testIds.zapDialog.content}>
        <ZapFlow />
      </div>
    </Dialog>
  );
};

const ZapDialog: FC = () => {
  return (
    <LiquidityContextProvider>
      <ZapContextProvider>
        <ZapDialogUI />
        <PoolSelectDialog />
      </ZapContextProvider>
    </LiquidityContextProvider>
  );
};

export default ZapDialog;
